import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendCrypto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 194,
	height: 183,
	viewBox: "0 0 194 183",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_4173_30185)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 132.606,
				cy: 120.606,
				r: 28.6055,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.145 126.467C151.225 138.18 139.362 145.308 127.647 142.387C115.937 139.467 108.809 127.603 111.73 115.891C114.649 104.177 126.513 97.0476 138.224 99.9677C149.937 102.888 157.065 114.753 154.145 126.467L154.145 126.467H154.145Z",
			fill: "#FFCE30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.145 126.467C151.225 138.18 139.362 145.308 127.647 142.387C115.937 139.467 108.809 127.603 111.73 115.891C114.649 104.177 126.513 97.0476 138.224 99.9677C149.937 102.888 157.065 114.753 154.145 126.467L154.145 126.467H154.145Z",
			fill: "url(#paint0_linear_4173_30185)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4173_30185)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M132.824 105.71L132.628 106.381V125.839L132.824 126.036L141.777 120.697L132.824 105.71Z",
					fill: "#A4A4A4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.824 105.71L123.87 120.697L132.824 126.036V116.592V105.71Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.824 127.745L132.713 127.881V134.812L132.824 135.137L141.782 122.409L132.824 127.745Z",
					fill: "#A4A4A4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.824 135.137V127.745L123.87 122.409L132.824 135.137Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.824 126.036L141.777 120.697L132.824 116.591V126.036Z",
					fill: "#8C8C8C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M123.87 120.697L132.824 126.036V116.591L123.87 120.697Z",
					fill: "#CECECE"
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_4173_30185)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 60.6055,
				cy: 121.606,
				r: 28.6055,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.8063 126.551C78.8862 138.264 67.0227 145.392 55.3082 142.471C43.5986 139.551 36.4702 127.687 39.3916 115.975C42.3105 104.26 54.174 97.1313 65.8849 100.051C77.5985 102.972 84.7265 114.837 81.806 126.551L81.8062 126.551H81.8063Z",
			fill: "#FFCE30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.8063 126.551C78.8862 138.264 67.0227 145.392 55.3082 142.471C43.5986 139.551 36.4702 127.687 39.3916 115.975C42.3105 104.26 54.174 97.1313 65.8849 100.051C77.5985 102.972 84.7265 114.837 81.806 126.551L81.8062 126.551H81.8063Z",
			fill: "url(#paint1_linear_4173_30185)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.8485 122.976C63.6894 122.988 62.8674 123.038 61.0338 123.038C59.5754 123.038 58.5399 122.994 58.1767 122.976C52.5406 122.726 48.3338 121.737 48.3338 120.553C48.3338 119.369 52.5406 118.381 58.1767 118.127V121.991C58.5452 122.018 59.6006 122.081 61.059 122.081C62.8091 122.081 63.6854 122.007 63.8432 121.993V118.13C69.4674 118.383 73.6649 119.372 73.6649 120.553C73.6649 121.735 69.4687 122.724 63.8432 122.975L63.8485 122.976ZM63.8485 117.73V114.273H71.6974V109H50.3278V114.273H58.1753V117.729C51.7968 118.024 47 119.298 47 120.824C47 122.351 51.7968 123.623 58.1753 123.92V135H63.8472V123.916C70.2111 123.621 75 122.348 75 120.823C75 119.298 70.2151 118.026 63.8472 117.729L63.8485 117.73Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_d_4173_30185)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 96.7095,
				cy: 60.6055,
				r: 28.6055,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.91 65.5506C114.99 77.2637 103.127 84.3921 91.4122 81.4712C79.7026 78.5511 72.5742 66.6868 75.4956 54.9747C78.4145 43.2603 90.278 36.1313 101.989 39.0515C113.703 41.9716 120.83 53.8371 117.91 65.5508L117.91 65.5506H117.91Z",
			fill: "#FFCE30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.91 65.5506C114.99 77.2637 103.127 84.3921 91.4122 81.4712C79.7026 78.5511 72.5742 66.6868 75.4956 54.9747C78.4145 43.2603 90.278 36.1313 101.989 39.0515C113.703 41.9716 120.83 53.8371 117.91 65.5508L117.91 65.5506H117.91Z",
			fill: "url(#paint2_linear_4173_30185)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.344 57.1466C106.779 54.237 104.564 52.6729 101.534 51.6295L102.517 47.6881L100.118 47.0903L99.1613 50.9279C98.5305 50.7706 97.8828 50.6224 97.239 50.4754L98.2025 46.6125L95.8048 46.0146L94.8216 49.9548C94.2996 49.8359 93.7869 49.7185 93.2896 49.5947L93.2923 49.5823L89.9837 48.7561L89.3455 51.3186C89.3455 51.3186 91.1255 51.7267 91.088 51.7518C92.0596 51.9943 92.2353 52.6374 92.2061 53.1472L91.0868 57.6374C91.1537 57.6544 91.2404 57.6789 91.3362 57.7174C91.2561 57.6975 91.171 57.6758 91.0826 57.6547L89.5136 63.9448C89.3949 64.2399 89.0935 64.6829 88.4142 64.5147C88.4383 64.5495 86.6704 64.0795 86.6704 64.0795L85.4792 66.8259L88.6015 67.6042C89.1823 67.7499 89.7515 67.9023 90.312 68.0456L89.3192 72.0322L91.7157 72.63L92.6989 68.6858C93.3536 68.8635 93.9889 69.0274 94.6109 69.182L93.631 73.1076L96.0304 73.7055L97.0231 69.7264C101.114 70.5006 104.191 70.1885 105.485 66.488C106.529 63.5086 105.433 61.7901 103.281 60.6695C104.849 60.308 106.03 59.2769 106.344 57.1469L106.344 57.1464L106.344 57.1466ZM100.862 64.8334C100.12 67.8127 95.1041 66.2022 93.4778 65.7983L94.7953 60.5168C96.4215 60.9228 101.637 61.7262 100.862 64.8334H100.862ZM101.604 57.1034C100.928 59.8135 96.7524 58.4367 95.398 58.099L96.5925 53.309C97.9469 53.6466 102.308 54.2767 101.604 57.1034H101.604Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_4173_30185",
				x: 72.0137,
				y: 60.0137,
				width: 121.184,
				height: 121.184,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.9931 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4173_30185"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4173_30185",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_4173_30185",
				x: .0137291,
				y: 61.0137,
				width: 121.184,
				height: 121.184,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.9931 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4173_30185"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4173_30185",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_4173_30185",
				x: 36.1177,
				y: .0137291,
				width: 121.184,
				height: 121.184,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15.9931 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4173_30185"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4173_30185",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4173_30185",
				x1: 132.937,
				y1: 149.492,
				x2: 132.937,
				y2: 121.178,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .0820223,
					stopColor: "#F09337"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F09337",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4173_30185",
				x1: 48.9724,
				y1: 160.171,
				x2: 60.5986,
				y2: 121.261,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .0820223,
						stopColor: "#F09337"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .506944,
						stopColor: "#F09337",
						stopOpacity: .537111
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F09337",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4173_30185",
				x1: 96.7026,
				y1: 82.1257,
				x2: 96.7026,
				y2: 60.2615,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .0820223,
					stopColor: "#F09337"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F09337",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_4173_30185",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 17.9123,
					height: 29.4274,
					fill: "white",
					transform: "translate(123.87 105.71)"
				})
			})
		] })
	]
});
export default SvgSendCrypto;
